


























































































import Vue from "vue";
import { mapState } from "vuex";
import Footer from "../components/master/Footer.vue";
import TenantSwitch from "../components/tenant-switch.vue";
import PasswordInput from "../components/common/passwordInput.vue";
import appconst from "../lib/appconst";
import AbpBase from "../lib/abpbase";

export default AbpBase.extend({
  components: { Footer, TenantSwitch, PasswordInput },
  data() {
    return {
      loginModel: {
        userNameOrEmailAddress: "",
        password: "",
        rememberMe: false,
      },
      confirmation: null,
      showChangeTenant: false,
      showConfirmEmail: false,
      rules: {
        userNameOrEmailAddress: [
          {
            required: true,
            message: "Please enter email address",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "Please enter your password", trigger: "blur" }],
      },
    };
  },
  watch: {},
  computed: {
    ...mapState("account", ["emailConfirmed", "confirmedEmailAddress"]),
  },
  mounted() {
    if (this.emailConfirmed === true && this.confirmedEmailAddress) {
      this.loginModel.userNameOrEmailAddress = this.confirmedEmailAddress;
    }

    this.getParameters();
  },
  methods: {
    getParameters() {
      if (this.$route.query && this.$route.query.UserId) {
        this.loginModel.userNameOrEmailAddress = this.$route.query.UserId;
      }
    },
    async confirmEmail() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let context = this;
      (context.$refs.loginform as any).validate(async (valid: boolean) => {
        if (valid) {
          this.$Message.loading({
            content: "Send Email Confirmation...",
            duration: 0,
          });

          let requestData = {
            emailAddress: context.loginModel.userNameOrEmailAddress,
          };

          context.$store.dispatch("account/sendEmailAddressConfirmation", requestData).then((response) => {
            setTimeout(() => {
              context.$Message.destroy();
            }, 500);
            target.disabled = false;
            context.$Notice.success({
              desc: "Your email address confirmation is sent. Please check your email box to confirm and activate your account.",
              duration: 0,
            });
          });
        }
      });
    },
    handleGoToRecover() {
      this.$Modal.remove();
      this.$router.push({
        name: "forgot",
      });
    },
    async login() {
      (this.$refs.loginform as any).validate(async (valid: boolean) => {
        if (valid) {
          this.$Message.loading({
            content: "Log into GOATSUCCESS...",
            duration: 0,
          });

          await this.$store
            .dispatch({
              type: "app/login",
              data: this.loginModel,
            })
            .then(() => {
              sessionStorage.setItem("rememberMe", this.loginModel.rememberMe ? "1" : "0");
              location.reload();
            })
            .catch((error) => {
              if (error.response.data.error) {
                if (error.response.data.error.code === 10001) {
                  this.showConfirmEmail = true;
                  this.confirmation = JSON.parse(error.response.data.error.details);
                } else if (error.response.data.error.code === 10002 || error.response.data.error.code === 10003) {
                  this.$Modal.error({
                    title: "Oops!",
                    render: (h) => {
                      return h("p", [h("span", {}, error.response.data.error.details + " "), h("a", { on: { click: this.handleGoToRecover } }, "Click here to recover your password.")]);
                    },
                  });
                }
              }
            });
        }
      });
    },
  },
});
